import React from "react"
import PropTypes from "prop-types"
import { Flex, Switch } from "antd"
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import IconWithBg from "ui/IconWithBg"
import { Text } from "ui/Typography"
import styles from "./TicketTypeCard.module.css"

export const TicketTypeCard = ({ ticket, onToggle, onEdit, onDelete }) => (
  <Flex vertical gap={8} className={styles.ticketCard}>
    <Flex justify="space-between" align="center">
      <Flex align="center" gap={8}>
        <Switch checked={ticket.enabled} onChange={(checked) => onToggle(ticket.id, checked)} />
        <Text className={styles.ticketTitle}>{ticket.title}</Text>
      </Flex>
      <Flex gap={8}>
        <IconWithBg icon={<EditOutlined />} onClick={() => onEdit(ticket)} />
        <IconWithBg icon={<DeleteOutlined />} onClick={() => onDelete(ticket.id)} />
      </Flex>
    </Flex>
    {ticket.description && (
      <Text className={styles.ticketDescription}>{ticket.description}</Text>
    )}
  </Flex>
)

TicketTypeCard.propTypes = {
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    enabled: PropTypes.bool.isRequired,
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}
